export const colors = {
  mainTextBlue: "#364969",
  mainGreen: "#467066",
  textWhite: "#fff",
  grayBackground: "#F6F6F6",
  colorBlue: "#3761ee",
  colorBorder: "#ecf0f5",
  colorNavItems: "#7881b2",
  colorGreyMuted: "#949ecf",
};
